import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';

import { GlobalActivityLog } from '@screens/GlobalActivityLog/GlobalActivityLog';

export type GlobalActivityStackParamsList = {
  home: undefined;
};

const Stack = createStackNavigator<GlobalActivityStackParamsList>();
export const GlobalActivityStack: React.FC = () => {
  return (
    <Stack.Navigator>
      <Stack.Screen
        name='home'
        component={GlobalActivityLog}
        options={{
          headerShown: false,
        }}
      />
    </Stack.Navigator>
  );
};
